import $ from "jquery";
import ProgressBar from "./ProgressBar";
let WebV2MovieDetails = require('../web/v2/movie_details');
export default class ContentTile {

    constructor(object, additional_classes=[]) {
        this.object = object;
        this.additional_classes = additional_classes;
    }

    element(include_progress=false) {
        let object_link = document.createElement("a");
        object_link.href = 'javascript: void(0);';
        object_link.tabIndex = '0';
        object_link.style.width = '100%';
        object_link.style.display = 'inline-block';
        object_link.dataset['id'] = this.object['id'];
        object_link.dataset['kind'] = this.object['kind'];

        for (let i in this.additional_classes) {
            object_link.classList.add(this.additional_classes[i]);
        }

        let tile = document.createElement("div");
        tile.classList.add('tile');
        tile.classList.add('tile-data');
        tile.classList.add('border');
        tile.classList.add('overflow-hidden');
        tile.classList.add('tile-item-movie-' + this.object['id']);
        tile.classList.add('overflow-hidden');

        let tile_media = document.createElement("div");
        tile_media.classList.add('tile__media');
        tile_media.classList.add('horizContainer');

        let cover_art_img = document.createElement("img");
        cover_art_img.classList.add('tile__img');

        cover_art_img.src = this.resolveCoverArtSrc();
        cover_art_img.alt = '';

        $(cover_art_img).bind('load', function (e) {
            let $loaded = $(this).parent().parent().find('.tile__title');
            if ($loaded) {
                $loaded.css('opacity', '0')
            }
        });

        tile_media.appendChild(cover_art_img);
        tile.appendChild(tile_media);

        let tile_details = document.createElement("div");
        tile_details.classList.add('tile__details');

        let tile_title = document.createElement("div");
        tile_title.classList.add('tile__title');
        tile_title.innerText = this.resolveName();
        tile_details.appendChild(tile_title);
        tile.appendChild(tile_details);

        if ( include_progress ) {
            let resume_time = this.object['resume_time'] ? this.object['resume_time'] : 5;
            let progress = new ProgressBar( this.object['duration'],  resume_time);
            let progress_bar = progress.element();
            if ( progress_bar ) {
                let tile_progress = document.createElement("div");
                tile_progress.classList.add('tile__details__progress');
                tile_progress.appendChild( progress_bar );
                tile.appendChild(tile_progress);
            }
        }

        object_link.appendChild(tile);

        object_link.addEventListener("click", (e) => {
            WebV2MovieDetails.displayModal();
            WebV2MovieDetails.initModalMovieDetails(object_link);
        });

        object_link.classList.add('bound');

        return object_link
    }

    resolveCoverArtSrc() {
        if (this.object['cover_art.expiring_url']) {
            return this.object['cover_art.expiring_url'];
        } else if (this.object['cover_art']) {
            return this.object['cover_art'];
        } else {
            return null;
        }
    }

    resolveName() {
        if (this.object['name']) {
            return this.object['name'];
        } else if ( this.object['title'] ) {
            return this.object['title'];
        } else {
            return null;
        }
    }
}